import { FileSpreadsheet, Download, Upload, FileText, Edit3, History } from 'lucide-react'
import { Button } from '@/components/ui/Button'

interface GerencialTopBarProps {
  totalRecords: number
  loading?: boolean
  exporting?: boolean
  onExport: () => void
  onImport: () => void
  onDownloadTemplate: () => void
  onEnterEditMode: () => void
  onOpenHistory: () => void
  canEdit: boolean
}

/**
 * Page header — magro, com título, contagem dinâmica e ações principais
 * todas inline (Importar / Modelo / Editar / Exportar).
 */
export function GerencialTopBar({
  totalRecords,
  loading,
  exporting,
  onExport,
  onImport,
  onDownloadTemplate,
  onEnterEditMode,
  onOpenHistory,
  canEdit,
}: GerencialTopBarProps) {
  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-monumenta bg-brand-primary/10 flex items-center justify-center shrink-0">
          <FileSpreadsheet className="w-5 h-5 text-brand-primary" />
        </div>
        <div className="min-w-0">
          <h1 className="text-2xl font-display font-bold text-white truncate">
            Fluxo Gerencial
          </h1>
          <p className="text-sm text-brand-gray truncate">
            Fechamento mensal · {loading ? 'carregando…' : `${totalRecords} registro${totalRecords === 1 ? '' : 's'} no período`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {/* Importar — ação primária do fechamento mensal, destacada. */}
        <Button variant="primary" size="sm" onClick={onImport} title="Importar planilha">
          <Upload className="w-4 h-4 mr-1.5" />
          Importar
        </Button>
        {canEdit && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onEnterEditMode}
            title="Entrar no modo edição em lote"
            className="text-warning hover:bg-warning/10"
          >
            <Edit3 className="w-4 h-4 mr-1.5" />
            Editar
          </Button>
        )}
        <Button variant="ghost" size="sm" onClick={onDownloadTemplate} title="Baixar planilha-modelo">
          <FileText className="w-4 h-4 mr-1.5" />
          Modelo
        </Button>
        <Button variant="ghost" size="sm" onClick={onOpenHistory} title="Histórico de auditoria da DRE">
          <History className="w-4 h-4 mr-1.5" />
          Histórico
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onExport}
          disabled={exporting || loading || totalRecords === 0}
          title="Exportar registros filtrados"
        >
          <Download className="w-4 h-4 mr-1.5" />
          {exporting ? 'Exportando…' : 'Exportar'}
        </Button>
      </div>
    </div>
  )
}
